// Generated by site/scripts/legal-documents.mjs. Do not edit.
export const CURRENT_TERMS_VERSION_V1 = "sha256-sp2O3beCqiGPeYtTWUVC2SMpz1j2ylcRH3xc_4MguBw";
export const CURRENT_TERMS_EFFECTIVE_DATE_V1 = "2026-09-07";
export const CURRENT_PRIVACY_VERSION_V1 = "sha256-olOEFyMsDfj7obB8thTR6Di-xjNpohZYLvhFjiIUFYk";
export const CURRENT_PRIVACY_EFFECTIVE_DATE_V1 = "2026-09-07";
export const CURRENT_CRIO_TERMS_VERSION_V1 = "sha256-vxWKhbFAf9hEMtPfNJqSBrEjn7n-cGctHX0hdz8Ar3I";
export const CURRENT_CRIO_PRIVACY_VERSION_V1 = "sha256-GgV6pub7mV8yFuwW-altVrwk_fY8yxDUifRd0lcM9jA";
// Preview document selection is refreshed by nonproduction builds; it is not an effective publication.
export const PREVIEW_TERMS_VERSION_V1 = "sha256-sp2O3beCqiGPeYtTWUVC2SMpz1j2ylcRH3xc_4MguBw";
export const PREVIEW_TERMS_EFFECTIVE_DATE_V1 = "2026-09-07";
export const PREVIEW_PRIVACY_VERSION_V1 = "sha256-olOEFyMsDfj7obB8thTR6Di-xjNpohZYLvhFjiIUFYk";
export const PREVIEW_PRIVACY_EFFECTIVE_DATE_V1 = "2026-09-07";
